/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { getOrDefaultInNestedMap, setInNestedMap } from "./nestedMap.js";
export function addToNestedSet(set, key1, key2) {
    setInNestedMap(set, key1, key2, true);
}
export function nestedSetContains(set, key1, key2) {
    return getOrDefaultInNestedMap(set, key1, key2, false);
}
//# sourceMappingURL=nestedSet.js.map